(function () {
  var builder = document.querySelector('[data-lp-chain-builder]');
  if (!builder) return;

  var dataScript = builder.querySelector('[data-builder-data]');
  var data = JSON.parse(dataScript.textContent);
  var chains = data.chains || [];
  var charms = data.charms || [];

  var selectedChain = null;
  var selectedCharms = [];
  var selectedColor = 'gold';
  var currentStep = 'basis';
  var lockedScrollY = 0;

  var charmSortMode = 'default';
  var charmColorFilter = 'all';
  var charmMenuOpen = false;

  var chainList     = builder.querySelector('[data-builder-chains]');
  var charmList     = builder.querySelector('[data-builder-charms]');
  var empty         = builder.querySelector('[data-builder-empty]');
  var chainImg      = builder.querySelector('[data-builder-chain-img]');
  var charmLayer    = builder.querySelector('[data-builder-charm-layer]');
  var summary       = builder.querySelector('[data-builder-summary]');
  var total         = builder.querySelector('[data-builder-total]');
  var floatingTotal = builder.querySelector('[data-builder-floating-total]');
  var previewCount  = builder.querySelector('[data-builder-preview-count]');
  var overviewCount = builder.querySelector('[data-builder-overview-count]');
  var addBtn        = builder.querySelector('[data-builder-add]');
  var stepPanels    = builder.querySelectorAll('[data-builder-step-panel]');
  var stepButtons   = builder.querySelectorAll('[data-builder-step-btn]');
  var nextButtons   = builder.querySelectorAll('[data-builder-next]');
  var prevButtons   = builder.querySelectorAll('[data-builder-prev]');
  var basisMessage    = builder.querySelector('[data-builder-message-basis]');
  var charmsMessage   = builder.querySelector('[data-builder-message-charms]');
  var overviewMessage = builder.querySelector('[data-builder-message-overview]');
  var mobileOpenBtn  = builder.querySelector('[data-builder-mobile-open]');
  var mobileCloseBtn = builder.querySelector('[data-builder-mobile-close]');
  var sheet       = builder.querySelector('[data-builder-sheet]');
  var sheetHandle = builder.querySelector('[data-builder-sheet-handle]');

  var charmSizeMultiplier = 3.8;

  var fallbackLayout = [
    { left: 50, top: 82, size: 11, rotate: 0 },
    { left: 39, top: 78, size: 11, rotate: 35 },
    { left: 61, top: 79, size: 11, rotate: -35 },
    { left: 29, top: 68, size: 11, rotate: 45 },
    { left: 70, top: 70, size: 11, rotate: -45 }
  ];

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function money(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function numberValue(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return isNaN(parsed) ? fallback : parsed;
  }

  function normalizeLayout(rawLayout) {
    var layout = rawLayout;

    if (!layout) return fallbackLayout;

    if (typeof layout === 'string') {
      try {
        layout = JSON.parse(layout.trim());
      } catch (e) {
        return fallbackLayout;
      }
    }

    if (!Array.isArray(layout)) return fallbackLayout;

    layout = layout.map(function (pos) {
      return {
        left:   numberValue(pos.left   != null ? pos.left   : pos.x,        50),
        top:    numberValue(pos.top    != null ? pos.top    : pos.y,        60),
        size:   numberValue(pos.size   != null ? pos.size   : pos.width,    12),
        rotate: numberValue(pos.rotate != null ? pos.rotate : pos.rotation,  0)
      };
    }).filter(function (pos) {
      return !isNaN(pos.left) && !isNaN(pos.top) && !isNaN(pos.size);
    });

    return layout.length ? layout : fallbackLayout;
  }

  function getActiveLayout() {
    return selectedChain ? normalizeLayout(selectedChain.charmLayout) : fallbackLayout;
  }

  function getColorLabel(color) {
    return color === 'silver' ? 'Silber' : 'Gold';
  }

  function swatchHtml(color, type) {
    var label = getColorLabel(color);

    var img = color === 'silver'
      ? 'https://cdn.shopify.com/s/files/1/0918/5817/4291/files/Design_ohne_Titel-110.jpg?v=1773866240'
      : 'https://cdn.shopify.com/s/files/1/0918/5817/4291/files/Design_ohne_Titel-111.jpg?v=1773866225';

    var attr = type === 'chain' ? 'data-chain-color' : 'data-charm-color';

    return (
      '<span class="lp-builder__card-color" ' + attr + '="' + color + '" role="button" aria-label="' + label + '" title="' + label + '">' +
        '<img src="' + img + '" alt="' + label + '">' +
      '</span>'
    );
  }

  function getChainVariants(chain) {
    return chain && Array.isArray(chain.variants) ? chain.variants : [];
  }

  function chainHasColor(chain, color) {
    var variants = getChainVariants(chain);

    if (variants.length) {
      return variants.some(function (variant) {
        return variant.color === color && variant.available !== false;
      });
    }

    return false;
  }

  function getChainVariant(chain, color) {
    var variants = getChainVariants(chain);

    var exact = variants.find(function (variant) {
      return variant.color === color && variant.available !== false;
    });

    if (exact) return exact;

    var fallback = variants.find(function (variant) {
      return variant.available !== false;
    });

    if (fallback) return fallback;

    return {
      id: chain.id,
      title: chain.title,
      price: chain.price,
      color: color,
      available: true,
      image: chain.thumbImage || ''
    };
  }

  function getSelectedChainVariant() {
    return selectedChain ? getChainVariant(selectedChain, selectedColor) : null;
  }

  function getChainCardImageSrc(chain, color) {
    if (!chain) return '';

    var variant = getChainVariant(chain, color);

    if (variant && variant.image) {
      return variant.image;
    }

    return chain.thumbImage || '';
  }

  function getChainPreviewSrc(chain, color) {
    if (!chain) return '';

    if (color === 'silver' && chain.previewImageSilver) {
      return chain.previewImageSilver;
    }

    return chain.previewImage || chain.thumbImage || '';
  }

  function getCharmVariants(charm) {
    return charm && Array.isArray(charm.variants) ? charm.variants : [];
  }

  function charmHasColor(charm, color) {
    var variants = getCharmVariants(charm);

    return variants.some(function (variant) {
      return variant.color === color && variant.available !== false;
    });
  }

  function getDefaultCharmColor(charm) {
    if (selectedColor && charmHasColor(charm, selectedColor)) {
      return selectedColor;
    }

    if (charmHasColor(charm, 'gold')) {
      return 'gold';
    }

    if (charmHasColor(charm, 'silver')) {
      return 'silver';
    }

    return '';
  }

  function getCharmVariant(charm, color) {
    var variants = getCharmVariants(charm);

    if (color) {
      var exact = variants.find(function (variant) {
        return variant.color === color && variant.available !== false;
      });

      if (exact) return exact;
    }

    var fallback = variants.find(function (variant) {
      return variant.available !== false;
    });

    if (fallback) return fallback;

    return {
      id: charm.id,
      title: charm.title,
      price: charm.price,
      color: color || '',
      available: true,
      image: charm.image || '',
      cardImage: charm.cardImage || ''
    };
  }

  function getCharmPreviewImageSrc(charm, color) {
    if (!charm) return '';

    var variant = getCharmVariant(charm, color || getDefaultCharmColor(charm));

    if (variant && variant.image) {
      return variant.image;
    }

    if (color === 'silver' && charm.imageSilver) {
      return charm.imageSilver;
    }

    return charm.image || charm.imageSilver || '';
  }

  function getCharmCardImageSrc(charm, color) {
    if (!charm) return '';

    var variant = getCharmVariant(charm, color || getDefaultCharmColor(charm));

    if (variant && variant.cardImage) {
      return variant.cardImage;
    }

    return charm.cardImage || charm.image || charm.imageSilver || '';
  }

  function getCharmCardPrice(charm, color) {
    var variant = getCharmVariant(charm, color || getDefaultCharmColor(charm));
    return variant && variant.price != null ? variant.price : charm.price;
  }

  function createCharmSelection(charm, color) {
    var finalColor = color || getDefaultCharmColor(charm);
    var variant = getCharmVariant(charm, finalColor);

    return {
      baseId: charm.id,
      productId: charm.productId,
      id: variant && variant.id ? variant.id : charm.id,
      title: charm.title,
      price: variant && variant.price != null ? variant.price : charm.price,
      url: charm.url,
      image: getCharmPreviewImageSrc(charm, finalColor),
      cardImage: getCharmCardImageSrc(charm, finalColor),
      color: variant && variant.color ? variant.color : finalColor,
      variants: charm.variants || []
    };
  }

  function getSelectedCharm(charmId) {
    return selectedCharms.find(function (item) {
      return String(item.baseId || item.id) === String(charmId);
    });
  }

  function getCharmSortPrice(charm) {
    var colorForPrice = charmColorFilter !== 'all'
      ? charmColorFilter
      : getDefaultCharmColor(charm);

    return getCharmCardPrice(charm, colorForPrice);
  }

  function getVisibleCharms() {
    var visible = charms.filter(function (charm) {
      if (charmColorFilter === 'gold') return charmHasColor(charm, 'gold');
      if (charmColorFilter === 'silver') return charmHasColor(charm, 'silver');
      return true;
    });

    visible.sort(function (a, b) {
      var priceA = getCharmSortPrice(a);
      var priceB = getCharmSortPrice(b);

      if (charmSortMode === 'price-asc') {
        return priceA - priceB;
      }

      if (charmSortMode === 'price-desc') {
        return priceB - priceA;
      }

      return 0;
    });

    return visible;
  }

  function getCharmDiscountInfo() {
    var freeCount = Math.floor(selectedCharms.length / 2);
    var freeIndexes = {};
    var discount = 0;

    if (freeCount <= 0) {
      return {
        freeCount: 0,
        freeIndexes: freeIndexes,
        discount: 0
      };
    }

    var sortedCharms = selectedCharms.map(function (charm, index) {
      return {
        index: index,
        price: charm.price || 0
      };
    }).sort(function (a, b) {
      if (a.price !== b.price) return a.price - b.price;
      return b.index - a.index;
    });

    sortedCharms.slice(0, freeCount).forEach(function (item) {
      freeIndexes[item.index] = true;
      discount += item.price;
    });

    return {
      freeCount: freeCount,
      freeIndexes: freeIndexes,
      discount: discount
    };
  }

  function getSubtotal() {
    var sum = 0;

    if (selectedChain) {
      var chainVariant = getSelectedChainVariant();
      sum += chainVariant && chainVariant.price != null ? chainVariant.price : selectedChain.price;
    }

    selectedCharms.forEach(function (charm) {
      sum += charm.price;
    });

    return sum;
  }

  function getTotal() {
    var subtotal = getSubtotal();
    var discountInfo = getCharmDiscountInfo();

    return Math.max(0, subtotal - discountInfo.discount);
  }

  function getCollapsedHeight() {
    var vh = window.innerHeight || document.documentElement.clientHeight || 700;

    if (window.matchMedia('(max-width: 420px)').matches) {
      return Math.min(Math.max(230, vh * 0.31), 252);
    }

    return Math.min(Math.max(245, vh * 0.33), 272);
  }

  function getExpandedHeight() {
    var vh = window.innerHeight || document.documentElement.clientHeight || 700;

    if (window.matchMedia('(max-width: 420px)').matches) {
      return Math.round(vh * 0.8);
    }

    return Math.round(vh * 0.78);
  }

  function setSheetHeight(height) {
    builder.style.setProperty('--lp-sheet-current-height', Math.round(height) + 'px');
  }

  function snapSheetTo(height, expanded) {
    builder.classList.remove('is-sheet-dragging');

    if (expanded) {
      builder.classList.add('is-sheet-expanded');
      builder.classList.remove('is-sheet-collapsed');
    } else {
      builder.classList.add('is-sheet-collapsed');
      builder.classList.remove('is-sheet-expanded');
    }

    requestAnimationFrame(function () {
      setSheetHeight(height);
    });
  }

  function expandSheet() {
    snapSheetTo(getExpandedHeight(), true);
  }

  function collapseSheet() {
    snapSheetTo(getCollapsedHeight(), false);
  }

  function toggleSheet() {
    if (builder.classList.contains('is-sheet-expanded')) {
      collapseSheet();
    } else {
      expandSheet();
    }
  }

  function lockPageScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow  = 'hidden';
    document.body.style.position  = 'fixed';
    document.body.style.top       = '-' + lockedScrollY + 'px';
    document.body.style.left      = '0';
    document.body.style.right     = '0';
    document.body.style.width     = '100%';
  }

  function unlockPageScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow  = '';
    document.body.style.position  = '';
    document.body.style.top       = '';
    document.body.style.left      = '';
    document.body.style.right     = '';
    document.body.style.width     = '';

    window.scrollTo(0, lockedScrollY || 0);
  }

  function openMobileBuilder() {
    builder.classList.add('is-mobile-open');
    builder.classList.add('is-sheet-collapsed');
    builder.classList.remove('is-sheet-expanded');
    builder.classList.remove('is-sheet-dragging');

    setSheetHeight(getCollapsedHeight());
    lockPageScroll();
  }

  function closeMobileBuilder() {
    builder.classList.remove('is-mobile-open');
    builder.classList.remove('is-sheet-dragging');

    unlockPageScroll();
  }

  function hideMessages() {
    [basisMessage, charmsMessage, overviewMessage].forEach(function (el) {
      if (el) el.style.display = 'none';
    });
  }

  function showMessage(step, text) {
    hideMessages();

    var target = null;

    if (step === 'basis') target = basisMessage;
    if (step === 'charms') target = charmsMessage;
    if (step === 'overview') target = overviewMessage;

    if (!target) return;

    target.textContent = text;
    target.style.display = 'block';
  }

  function setStep(step) {
    if (step === 'charms' && !selectedChain) {
      showMessage('basis', 'Bitte wähle zuerst eine Basis aus.');
      return;
    }

    if (step === 'overview' && !selectedChain) {
      showMessage('basis', 'Bitte wähle zuerst eine Basis aus.');
      return;
    }

    currentStep = step;
    hideMessages();

    if (isMobile() && step === 'overview') {
      expandSheet();
    }

    stepPanels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.builderStepPanel === step);
    });

    stepButtons.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.builderStepBtn === step);
    });
  }

  function charmToolbarHtml() {
    return (
      '<div class="lp-builder__charm-toolbar" data-builder-charm-toolbar>' +
        '<button type="button" class="lp-builder__charm-filter-toggle" data-builder-charm-menu-toggle aria-label="Charms filtern und sortieren" aria-expanded="false">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M4 6h16"></path>' +
            '<path d="M7 12h10"></path>' +
            '<path d="M10 18h4"></path>' +
          '</svg>' +
        '</button>' +
        '<div class="lp-builder__charm-dropdown" data-builder-charm-menu>' +
          '<div class="lp-builder__charm-dropdown-title">Sortieren</div>' +
          '<div class="lp-builder__charm-dropdown-group">' +
            '<button type="button" class="lp-builder__charm-dropdown-option is-active" data-builder-charm-sort-option="default">Standard</button>' +
            '<button type="button" class="lp-builder__charm-dropdown-option" data-builder-charm-sort-option="price-asc">Preis aufsteigend</button>' +
            '<button type="button" class="lp-builder__charm-dropdown-option" data-builder-charm-sort-option="price-desc">Preis absteigend</button>' +
          '</div>' +
          '<div class="lp-builder__charm-dropdown-title">Farbe</div>' +
          '<div class="lp-builder__charm-dropdown-group">' +
            '<button type="button" class="lp-builder__charm-dropdown-option is-active" data-builder-charm-filter="all">Alle Farben</button>' +
            '<button type="button" class="lp-builder__charm-dropdown-option" data-builder-charm-filter="gold">Nur Gold</button>' +
            '<button type="button" class="lp-builder__charm-dropdown-option" data-builder-charm-filter="silver">Nur Silber</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function ensureCharmToolbar() {
    var existing = builder.querySelector('[data-builder-charm-toolbar]');
    if (existing) return;

    var charmsPanel = builder.querySelector('[data-builder-step-panel="charms"]');

    if (charmsPanel) {
      charmsPanel.insertAdjacentHTML('beforeend', charmToolbarHtml());
    }
  }

  function setCharmMenuOpen(open) {
    charmMenuOpen = open;

    var toggle = builder.querySelector('[data-builder-charm-menu-toggle]');
    var menu = builder.querySelector('[data-builder-charm-menu]');

    if (toggle) {
      toggle.classList.toggle('is-open', charmMenuOpen);
      toggle.setAttribute('aria-expanded', charmMenuOpen ? 'true' : 'false');
    }

    if (menu) {
      menu.classList.toggle('is-open', charmMenuOpen);
    }
  }

  function renderCharmToolbarActive() {
    builder.querySelectorAll('[data-builder-charm-sort-option]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.builderCharmSortOption === charmSortMode);
    });

    builder.querySelectorAll('[data-builder-charm-filter]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.builderCharmFilter === charmColorFilter);
    });

    setCharmMenuOpen(charmMenuOpen);
  }

  function optionHtml(item, type) {
    var thumb = '';
    var priceValue = item.price;
    var productLink = '';
    var cardColors = '';

    if (type === 'chain') {
      thumb = getChainCardImageSrc(item, 'gold');
      priceValue = getChainVariant(item, 'gold').price || item.price;

      if (item.url) {
        productLink =
          '<span class="lp-builder__product-link" data-chain-product-url="' + item.url + '" aria-label="Produkt ansehen" title="Produkt ansehen">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>' +
              '<path d="M15 3h6v6"></path>' +
              '<path d="M10 14L21 3"></path>' +
            '</svg>' +
          '</span>';
      }

      var chainHasGold = chainHasColor(item, 'gold');
      var chainHasSilver = chainHasColor(item, 'silver');

      if (chainHasGold || chainHasSilver) {
        cardColors += '<span class="lp-builder__card-colors" aria-label="Farbe wählen">';

        if (chainHasGold) {
          cardColors += swatchHtml('gold', 'chain');
        }

        if (chainHasSilver) {
          cardColors += swatchHtml('silver', 'chain');
        }

        cardColors += '</span>';
      }
    } else {
      var charmDefaultColor = getDefaultCharmColor(item);

      if (charmColorFilter === 'gold' && charmHasColor(item, 'gold')) {
        charmDefaultColor = 'gold';
      }

      if (charmColorFilter === 'silver' && charmHasColor(item, 'silver')) {
        charmDefaultColor = 'silver';
      }

      thumb = getCharmCardImageSrc(item, charmDefaultColor);
      priceValue = getCharmCardPrice(item, charmDefaultColor);

      var charmHasGold = charmHasColor(item, 'gold');
      var charmHasSilver = charmHasColor(item, 'silver');

      if (charmHasGold || charmHasSilver) {
        cardColors += '<span class="lp-builder__card-colors" aria-label="Farbe wählen">';

        if (charmHasGold) {
          cardColors += swatchHtml('gold', 'charm');
        }

        if (charmHasSilver) {
          cardColors += swatchHtml('silver', 'charm');
        }

        cardColors += '</span>';
      }
    }

    return (
      '<button type="button" class="lp-builder__option" data-' + type + '-id="' + item.id + '">' +
        productLink +
        '<span class="lp-builder__thumb">' +
          (thumb ? '<img src="' + thumb + '" alt="' + item.title + '" loading="lazy" data-' + type + '-card-img>' : '') +
        '</span>' +
        '<p class="lp-builder__name">' + item.title + '</p>' +
        '<div class="lp-builder__price" data-' + type + '-card-price>' + money(priceValue) + '</div>' +
        cardColors +
      '</button>'
    );
  }

  function renderOptions() {
    ensureCharmToolbar();

    chainList.innerHTML = chains.length
      ? chains.map(function (item) { return optionHtml(item, 'chain'); }).join('')
      : '<p>Keine Produkte in der Collection diy-ketten gefunden.</p>';

    var visibleCharms = getVisibleCharms();

    charmList.innerHTML = visibleCharms.length
      ? visibleCharms.map(function (item) { return optionHtml(item, 'charm'); }).join('')
      : '<p class="lp-builder__no-filter-results">Keine passenden Charms gefunden.</p>';

    renderCharmToolbarActive();
  }

  function renderChainCardImages() {
    builder.querySelectorAll('[data-chain-id]').forEach(function (btn) {
      var cardImg = btn.querySelector('[data-chain-card-img]');
      var cardPrice = btn.querySelector('[data-chain-card-price]');

      var chain = chains.find(function (item) {
        return String(item.id) === String(btn.dataset.chainId);
      });

      if (!chain) return;

      var cardColor = 'gold';

      if (selectedChain && String(selectedChain.id) === String(chain.id)) {
        cardColor = selectedColor;
      }

      var nextSrc = getChainCardImageSrc(chain, cardColor);
      var nextVariant = getChainVariant(chain, cardColor);

      if (cardImg && nextSrc && cardImg.getAttribute('src') !== nextSrc) {
        cardImg.setAttribute('src', nextSrc);
      }

      if (cardPrice && nextVariant && nextVariant.price != null) {
        cardPrice.textContent = money(nextVariant.price);
      }
    });
  }

  function renderCharmCardImages() {
    builder.querySelectorAll('[data-charm-id]').forEach(function (btn) {
      var cardImg = btn.querySelector('[data-charm-card-img]');
      var cardPrice = btn.querySelector('[data-charm-card-price]');

      var charm = charms.find(function (item) {
        return String(item.id) === String(btn.dataset.charmId);
      });

      if (!charm) return;

      var selectedCharm = getSelectedCharm(charm.id);
      var cardColor = selectedCharm && selectedCharm.color ? selectedCharm.color : getDefaultCharmColor(charm);

      if (charmColorFilter === 'gold' && charmHasColor(charm, 'gold')) {
        cardColor = 'gold';
      }

      if (charmColorFilter === 'silver' && charmHasColor(charm, 'silver')) {
        cardColor = 'silver';
      }

      var nextSrc = getCharmCardImageSrc(charm, cardColor);
      var nextPrice = getCharmCardPrice(charm, cardColor);

      if (cardImg && nextSrc && cardImg.getAttribute('src') !== nextSrc) {
        cardImg.setAttribute('src', nextSrc);
      }

      if (cardPrice && nextPrice != null) {
        cardPrice.textContent = money(nextPrice);
      }
    });
  }

  function renderPreview() {
    var layout = getActiveLayout();
    var maxCharms = selectedChain ? layout.length : 0;

    empty.style.display = selectedChain ? 'none' : 'grid';

    if (selectedChain) {
      var previewSrc = getChainPreviewSrc(selectedChain, selectedColor);

      if (previewSrc) {
        chainImg.src = previewSrc;
        chainImg.alt = selectedChain.title;
        chainImg.style.display = 'block';
      } else {
        chainImg.style.display = 'none';
      }
    } else {
      chainImg.style.display = 'none';
    }

    charmLayer.innerHTML = '';

    selectedCharms.forEach(function (charm, index) {
      if (index >= layout.length) return;

      var pos = layout[index];
      var el = document.createElement('div');

      el.className = 'lp-builder__charm-preview';
      el.style.left = pos.left + '%';
      el.style.top = pos.top + '%';
      el.style.width = (pos.size * charmSizeMultiplier) + '%';
      el.style.transform = 'translate(-50%, -50%) rotate(' + pos.rotate + 'deg)';

      if (charm.image) {
        el.innerHTML = '<img src="' + charm.image + '" alt="' + charm.title + '">';
      }

      charmLayer.appendChild(el);
    });

    previewCount.textContent = selectedCharms.length + ' / ' + maxCharms + ' charms';
  }

  function renderSummary() {
    var rows = [];
    var discountInfo = getCharmDiscountInfo();

    if (selectedChain) {
      var chainVariant = getSelectedChainVariant();
      var chainPrice = chainVariant && chainVariant.price != null ? chainVariant.price : selectedChain.price;
      var chainColorLabel = chainVariant && chainVariant.color ? ' - ' + getColorLabel(chainVariant.color) : '';

      rows.push(
        '<li><span>' + selectedChain.title + chainColorLabel + '</span><span>' + money(chainPrice) + '</span></li>'
      );
    }

    selectedCharms.forEach(function (charm, index) {
      var colorLabel = charm.color ? ' - ' + getColorLabel(charm.color) : '';
      var priceHtml = '';

      if (discountInfo.freeIndexes[index]) {
        priceHtml =
          '<span style="display:inline-flex;align-items:center;gap:7px;">' +
            '<s style="color:#888;font-weight:400;">' + money(charm.price) + '</s>' +
            '<strong style="color:#b00020;">Gratis</strong>' +
          '</span>';
      } else {
        priceHtml = money(charm.price);
      }

      rows.push('<li><span>' + charm.title + colorLabel + '</span><span>' + priceHtml + '</span></li>');
    });

    if (discountInfo.discount > 0) {
      rows.push(
        '<li><span style="color:#b00020;font-weight:600;">Aktion: Jedes 2. Charm gratis</span><span style="color:#b00020;font-weight:700;">− ' + money(discountInfo.discount) + '</span></li>'
      );
    }

    if (!rows.length) {
      rows.push('<li><span>Noch keine Basis ausgewählt</span><span>€0,00</span></li>');
    }

    summary.innerHTML = rows.join('');

    var totalValue = getTotal();
    var countText = selectedCharms.length + ' Charms ausgewählt';

    if (discountInfo.freeCount > 0) {
      countText += ' · ' + discountInfo.freeCount + ' gratis';
    }

    total.textContent = money(totalValue);
    floatingTotal.textContent = money(totalValue);
    overviewCount.textContent = countText;
    addBtn.disabled = !selectedChain;
  }

  function renderActive() {
    var layout = getActiveLayout();
    var maxCharms = selectedChain ? layout.length : 0;

    builder.querySelectorAll('[data-chain-id]').forEach(function (btn) {
      btn.classList.toggle(
        'is-active',
        selectedChain && String(selectedChain.id) === btn.dataset.chainId
      );
    });

    builder.querySelectorAll('[data-chain-color]').forEach(function (swatch) {
      var parentChain = swatch.closest('[data-chain-id]');
      var isSelectedChain = selectedChain && parentChain && String(selectedChain.id) === parentChain.dataset.chainId;

      swatch.classList.toggle(
        'is-active',
        isSelectedChain && swatch.dataset.chainColor === selectedColor
      );
    });

    builder.querySelectorAll('[data-charm-id]').forEach(function (btn) {
      var active = selectedCharms.some(function (charm) {
        return String(charm.baseId || charm.id) === btn.dataset.charmId;
      });

      btn.classList.toggle('is-active', active);
      btn.disabled = !selectedChain || (!active && selectedCharms.length >= maxCharms);
    });

    builder.querySelectorAll('[data-charm-color]').forEach(function (swatch) {
      var parentCharm = swatch.closest('[data-charm-id]');
      if (!parentCharm) return;

      var selectedCharm = getSelectedCharm(parentCharm.dataset.charmId);

      swatch.classList.toggle(
        'is-active',
        selectedCharm && selectedCharm.color === swatch.dataset.charmColor
      );
    });

    renderCharmToolbarActive();
    renderChainCardImages();
    renderCharmCardImages();
  }

  function renderAll() {
    renderPreview();
    renderSummary();
    renderActive();
  }

  function selectChain(chainId, color) {
    var nextChain = chains.find(function (item) {
      return String(item.id) === String(chainId);
    });

    if (!nextChain) return;

    if (color) {
      selectedColor = color;
    }

    if (!chainHasColor(nextChain, selectedColor)) {
      if (chainHasColor(nextChain, 'gold')) {
        selectedColor = 'gold';
      } else if (chainHasColor(nextChain, 'silver')) {
        selectedColor = 'silver';
      }
    }

    selectedChain = nextChain;

    var layout = getActiveLayout();

    if (selectedCharms.length > layout.length) {
      selectedCharms = selectedCharms.slice(0, layout.length);
      showMessage('basis', 'Diese Basis hat nur ' + layout.length + ' Charm-Plätze. Die Auswahl wurde angepasst.');
    } else {
      hideMessages();
    }

    renderAll();
  }

  function toggleCharm(charmId) {
    if (!selectedChain) {
      showMessage('basis', 'Bitte wähle zuerst eine Basis aus.');
      setStep('basis');
      return;
    }

    var layout = getActiveLayout();
    var maxCharms = layout.length;

    var charm = charms.find(function (item) {
      return String(item.id) === String(charmId);
    });

    if (!charm) return;

    var exists = getSelectedCharm(charm.id);

    if (!exists && selectedCharms.length >= maxCharms) {
      showMessage('charms', 'Für diese Basis kannst du maximal ' + maxCharms + ' Charms auswählen.');
      return;
    }

    if (exists) {
      selectedCharms = selectedCharms.filter(function (item) {
        return String(item.baseId || item.id) !== String(charm.id);
      });
    } else {
      var defaultColor = getDefaultCharmColor(charm);

      if (charmColorFilter === 'gold' && charmHasColor(charm, 'gold')) {
        defaultColor = 'gold';
      }

      if (charmColorFilter === 'silver' && charmHasColor(charm, 'silver')) {
        defaultColor = 'silver';
      }

      selectedCharms = selectedCharms.concat(createCharmSelection(charm, defaultColor));
    }

    hideMessages();
    renderAll();
  }

  function selectCharmColor(charmId, color) {
    if (!selectedChain) {
      showMessage('basis', 'Bitte wähle zuerst eine Basis aus.');
      setStep('basis');
      return;
    }

    var layout = getActiveLayout();
    var maxCharms = layout.length;

    var charm = charms.find(function (item) {
      return String(item.id) === String(charmId);
    });

    if (!charm) return;

    var existingIndex = selectedCharms.findIndex(function (item) {
      return String(item.baseId || item.id) === String(charm.id);
    });

    if (existingIndex === -1 && selectedCharms.length >= maxCharms) {
      showMessage('charms', 'Für diese Basis kannst du maximal ' + maxCharms + ' Charms auswählen.');
      return;
    }

    var nextSelection = createCharmSelection(charm, color);

    if (existingIndex > -1) {
      selectedCharms[existingIndex] = nextSelection;
    } else {
      selectedCharms = selectedCharms.concat(nextSelection);
    }

    hideMessages();
    renderAll();
  }

  function bindCharmToolbar() {
    builder.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-builder-charm-menu-toggle]');

      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        setCharmMenuOpen(!charmMenuOpen);
        return;
      }

      var sortOption = e.target.closest('[data-builder-charm-sort-option]');

      if (sortOption) {
        e.preventDefault();
        e.stopPropagation();

        charmSortMode = sortOption.dataset.builderCharmSortOption || 'default';
        setCharmMenuOpen(false);
        renderOptions();
        renderAll();
        return;
      }

      var filterOption = e.target.closest('[data-builder-charm-filter]');

      if (filterOption) {
        e.preventDefault();
        e.stopPropagation();

        charmColorFilter = filterOption.dataset.builderCharmFilter || 'all';
        setCharmMenuOpen(false);
        renderOptions();
        renderAll();
        return;
      }

      var toolbar = e.target.closest('[data-builder-charm-toolbar]');

      if (!toolbar && charmMenuOpen) {
        setCharmMenuOpen(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && charmMenuOpen) {
        setCharmMenuOpen(false);
      }
    });
  }

  function bindOptionList(list, type) {
    var startX = 0;
    var startY = 0;
    var moved = false;

    list.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moved = false;
    }, { passive: true });

    list.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;

      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);

      if (dx > 10 || dy > 10) moved = true;
    }, { passive: true });

    list.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
        return;
      }

      if (type === 'chain') {
        var productLink = e.target.closest('[data-chain-product-url]');

        if (productLink) {
          e.preventDefault();
          e.stopPropagation();

          var productUrl = productLink.dataset.chainProductUrl;

          if (productUrl) {
            window.location.href = productUrl;
          }

          return;
        }

        var colorSwatch = e.target.closest('[data-chain-color]');

        if (colorSwatch) {
          var chainBtnForColor = colorSwatch.closest('[data-chain-id]');
          if (!chainBtnForColor || chainBtnForColor.disabled) return;

          selectChain(chainBtnForColor.dataset.chainId, colorSwatch.dataset.chainColor);
          return;
        }
      }

      if (type === 'charm') {
        var charmColorSwatch = e.target.closest('[data-charm-color]');

        if (charmColorSwatch) {
          var charmBtnForColor = charmColorSwatch.closest('[data-charm-id]');
          if (!charmBtnForColor || charmBtnForColor.disabled) return;

          selectCharmColor(charmBtnForColor.dataset.charmId, charmColorSwatch.dataset.charmColor);
          return;
        }
      }

      var selector = type === 'chain' ? '[data-chain-id]' : '[data-charm-id]';
      var btn = e.target.closest(selector);

      if (!btn || btn.disabled) return;

      if (type === 'chain') {
        selectChain(btn.dataset.chainId);
      } else {
        toggleCharm(btn.dataset.charmId);
      }
    });
  }

  function getCartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  function getCartSections() {
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      }).slice(0, 5);
    }

    return [
      'cart-drawer',
      'cart-icon-bubble',
      'cart-live-region-text',
      'cart-notification-product',
      'cart-notification-button'
    ];
  }

  function replaceSectionHtml(sectionId, html) {
    if (!html) return;

    var parsed = new DOMParser().parseFromString(html, 'text/html');

    if (sectionId === 'cart-icon-bubble') {
      var newBubble = parsed.querySelector('#shopify-section-cart-icon-bubble');
      var oldBubble = document.querySelector('#shopify-section-cart-icon-bubble');

      if (newBubble && oldBubble) {
        oldBubble.innerHTML = newBubble.innerHTML;
        return;
      }

      var newBubbleInner = parsed.querySelector('[id*="cart-icon-bubble"], .cart-count-bubble');
      var oldBubbleInner = document.querySelector('[id*="cart-icon-bubble"], .cart-count-bubble');

      if (newBubbleInner && oldBubbleInner) {
        oldBubbleInner.innerHTML = newBubbleInner.innerHTML;
      }

      return;
    }

    if (sectionId === 'cart-drawer') {
      var newDrawer = parsed.querySelector('cart-drawer');
      var oldDrawer = document.querySelector('cart-drawer');

      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
        oldDrawer.classList.remove('is-empty');
        return;
      }

      var newDrawerInner = parsed.querySelector('#CartDrawer, .cart-drawer, [data-cart-drawer]');
      var oldDrawerInner = document.querySelector('#CartDrawer, .cart-drawer, [data-cart-drawer]');

      if (newDrawerInner && oldDrawerInner) {
        oldDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }

      return;
    }

    var newSection = parsed.querySelector('#shopify-section-' + sectionId);
    var oldSection = document.querySelector('#shopify-section-' + sectionId);

    if (newSection && oldSection) {
      oldSection.innerHTML = newSection.innerHTML;
    }
  }

  function updateCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    Object.keys(parsedState.sections).forEach(function (sectionId) {
      replaceSectionHtml(sectionId, parsedState.sections[sectionId]);
    });
  }

  function openCartDrawer(parsedState) {
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');

      if (typeof cartDrawer.renderContents === 'function' && parsedState) {
        try {
          cartDrawer.renderContents(parsedState);
          return;
        } catch (e) {}
      }

      if (typeof cartDrawer.open === 'function') {
        try {
          cartDrawer.open();
          return;
        } catch (e) {}
      }
    }

    var cartNotification = document.querySelector('cart-notification');

    if (cartNotification) {
      if (typeof cartNotification.renderContents === 'function' && parsedState) {
        try {
          cartNotification.renderContents(parsedState);
          return;
        } catch (e) {}
      }

      if (typeof cartNotification.open === 'function') {
        try {
          cartNotification.open();
          return;
        } catch (e) {}
      }
    }

    var possibleDrawers = [
      document.querySelector('#CartDrawer'),
      document.querySelector('.cart-drawer'),
      document.querySelector('[data-cart-drawer]'),
      document.querySelector('.drawer--cart'),
      document.querySelector('[id*="CartDrawer"]')
    ].filter(Boolean);

    possibleDrawers.forEach(function (drawer) {
      drawer.classList.add('active');
      drawer.classList.add('is-open');
      drawer.classList.add('animate');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
    });

    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
  }

  function submitBuilderSelection() {
    if (!selectedChain) return;

    var chainVariant = getSelectedChainVariant();

    var chainCartItem = {
      id: chainVariant && chainVariant.id ? chainVariant.id : selectedChain.id,
      quantity: 1,
      title: selectedChain.title,
      builderColor: chainVariant && chainVariant.color ? getColorLabel(chainVariant.color) : getColorLabel(selectedColor)
    };

    var selectedItems = [chainCartItem].concat(selectedCharms);
    var cartSections = getCartSections();

    addBtn.disabled = true;
    addBtn.textContent = 'Wird hinzugefügt...';

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: selectedItems.map(function (item) {
          var properties = {
            'LAPARELLA Builder': 'Individuelle Auswahl'
          };

          if (item.builderColor) {
            properties.Farbe = item.builderColor;
          }

          if (item.color && !item.builderColor) {
            properties.Farbe = getColorLabel(item.color);
          }

          if (!item.builderColor && item.baseId) {
            properties.Aktion = 'Jedes 2. Charm gratis';
          }

          return {
            id: Number(item.id),
            quantity: 1,
            properties: properties
          };
        }),
        sections: cartSections,
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          throw json;
        }

        return json;
      });
    })
    .then(function (parsedState) {
      updateCartSections(parsedState);
      openCartDrawer(parsedState);

      showMessage('overview', 'Deine Auswahl wurde in den Warenkorb gelegt. Der Rabatt wird im Warenkorb/Checkout automatisch angewendet.');
      addBtn.textContent = 'In den Warenkorb';
      addBtn.disabled = false;
    })
    .catch(function (error) {
      var message = 'Leider konnte die Auswahl nicht hinzugefügt werden.';

      if (error && error.description) {
        message = error.description;
      } else if (error && error.message) {
        message = error.message;
      }

      showMessage('overview', message);
      addBtn.textContent = 'In den Warenkorb';
      addBtn.disabled = false;
    });
  }

  renderOptions();
  renderAll();
  setStep(currentStep);
  bindCharmToolbar();

  if (mobileOpenBtn) {
    mobileOpenBtn.addEventListener('click', openMobileBuilder);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', closeMobileBuilder);
  }

  if (sheetHandle && sheet) {
    var isDraggingSheet = false;
    var pointerStartY = 0;
    var pointerLastY = 0;
    var startSheetHeight = 0;
    var lastKnownHeight = 0;
    var animationFrame = null;
    var activePointerId = null;
    var lastMoveTime = 0;
    var velocity = 0;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function applyDragHeight() {
      animationFrame = null;

      var minHeight = getCollapsedHeight();
      var maxHeight = getExpandedHeight();
      var dragDistance = pointerStartY - pointerLastY;
      var nextHeight = clamp(startSheetHeight + dragDistance, minHeight, maxHeight);

      lastKnownHeight = nextHeight;
      setSheetHeight(nextHeight);
    }

    function finishDrag(e) {
      if (!isDraggingSheet) return;

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
        applyDragHeight();
      }

      var minHeight = getCollapsedHeight();
      var maxHeight = getExpandedHeight();
      var midpoint = minHeight + ((maxHeight - minHeight) * 0.42);
      var projectedHeight = lastKnownHeight - (velocity * 180);
      var moved = Math.abs(pointerStartY - pointerLastY);

      isDraggingSheet = false;
      activePointerId = null;
      document.body.style.userSelect = '';

      if (moved < 6) {
        toggleSheet();
      } else if (projectedHeight >= midpoint) {
        expandSheet();
      } else {
        collapseSheet();
      }

      try {
        sheetHandle.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    sheetHandle.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;

      e.preventDefault();

      isDraggingSheet = true;
      activePointerId = e.pointerId;
      pointerStartY = e.clientY;
      pointerLastY = e.clientY;
      startSheetHeight = sheet.getBoundingClientRect().height;
      lastKnownHeight = startSheetHeight;
      lastMoveTime = performance.now();
      velocity = 0;

      document.body.style.userSelect = 'none';
      builder.classList.add('is-sheet-dragging');
      setSheetHeight(startSheetHeight);

      try {
        sheetHandle.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    sheetHandle.addEventListener('pointermove', function (e) {
      if (!isDraggingSheet) return;
      if (activePointerId !== null && e.pointerId !== activePointerId) return;

      e.preventDefault();

      var now = performance.now();
      var deltaY = e.clientY - pointerLastY;
      var deltaTime = now - lastMoveTime;

      if (deltaTime > 0) velocity = deltaY / deltaTime;

      pointerLastY = e.clientY;
      lastMoveTime = now;

      if (!animationFrame) animationFrame = requestAnimationFrame(applyDragHeight);
    });

    sheetHandle.addEventListener('pointerup', finishDrag);

    sheetHandle.addEventListener('pointercancel', function (e) {
      if (!isDraggingSheet) return;

      isDraggingSheet = false;
      activePointerId = null;
      document.body.style.userSelect = '';
      builder.classList.remove('is-sheet-dragging');

      if (builder.classList.contains('is-sheet-expanded')) {
        expandSheet();
      } else {
        collapseSheet();
      }

      try {
        sheetHandle.releasePointerCapture(e.pointerId);
      } catch (err) {}
    });
  }

  stepButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setStep(btn.dataset.builderStepBtn);
    });
  });

  nextButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setStep(btn.dataset.builderNext);
    });
  });

  prevButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setStep(btn.dataset.builderPrev);
    });
  });

  bindOptionList(chainList, 'chain');
  bindOptionList(charmList, 'charm');

  addBtn.addEventListener('click', submitBuilderSelection);

  window.addEventListener('resize', function () {
    if (!builder.classList.contains('is-mobile-open')) return;

    if (!isMobile()) {
      builder.classList.remove('is-mobile-open');
      unlockPageScroll();
      return;
    }

    if (builder.classList.contains('is-sheet-expanded')) {
      setSheetHeight(getExpandedHeight());
    } else {
      setSheetHeight(getCollapsedHeight());
    }
  });
})();